export const languajeList = [
  { id: 0, name: "IDIOMA DE LA PAGINA" },
  { id: 1, name: "es" },
  { id: 2, name: "en" },
];
